module.exports = __webpack_public_path__ + "img/process_5.4b00a7ff.svg";